import { AbstractControl, ValidationErrors } from '@angular/forms';
import { ELOQUA_EMAIL_PROVIDER_BLACKLIST } from '@core/config';
import { SpsLogger } from '@lib/utils/logger/sps-logger';

export class SpsFormValidator {
  static validateEmailBlacklisted = (input: AbstractControl | string): ValidationErrors | null => {
    try {
      const value = (typeof input === 'string' ? input : input.value) ?? '';
      const provider = /@(.+)\..+$/.exec(value.toLowerCase())?.[1] ?? '';

      const isBlacklisted = ELOQUA_EMAIL_PROVIDER_BLACKLIST.some(blacklisted => provider === blacklisted);

      return isBlacklisted ? { blacklisted: true } : null;
    } catch (e) {
      SpsLogger.warn(e);

      return null;
    }
  };
}
